export default __webpack_public_path__ + "staticlp1/media/marie-claire.e0a35ff1.jpg";